export default __webpack_public_path__ + "static/media/warning.63593dae.svg";